import { Link } from "react-router-dom";
import { avatarUrl } from "../../lib/avatars";
import { Emblem } from "../shop/Emblem";

export const Avatar = ({ id, size = "h-10 w-10", ring = true }) => {
  const url = avatarUrl(id);
  return url
    ? <img src={url} alt="" loading="lazy" className={`${size} rounded-full object-cover ${ring ? "ring-2 ring-[#F2C230]" : ""}`} />
    : <span className={`${size} rounded-full bg-[#241A3A] grid place-items-center ${ring ? "ring-2 ring-[#F2C230]" : ""}`}><Emblem className="h-3/5 w-3/5" /></span>;
};

export const MemberChip = ({ author, testid }) => (
  <Link to={`/u/${author?.display_name}`} className="flex items-center gap-3 group" data-testid={testid}>
    <Avatar id={author?.avatar} />
    <span>
      <span className="block text-sm font-semibold text-[#120E1F] group-hover:text-[#6E3FB8] transition-colors">{author?.display_name || "Trainer"}</span>
      <span className="text-[11px] text-[#707783]">Level {author?.level || 1}{author?.role === "admin" ? " · Jolgen Team" : ""}</span>
    </span>
  </Link>
);

export const LevelBar = ({ m, dark = false }) => (
  <div data-testid="level-bar">
    <div className={`h-2 rounded-full overflow-hidden ${dark ? "bg-white/10" : "bg-[#120E1F]/10"}`}>
      <div className="h-full bg-gradient-to-r from-[#F2C230] to-[#8A5CD6] transition-[width] duration-700" style={{ width: `${(m.xp_in_level / m.xp_per_level) * 100}%` }} />
    </div>
    <p className={`text-[11px] mt-1.5 font-mono ${dark ? "text-white/60" : "text-[#707783]"}`}>{m.xp_in_level} / {m.xp_per_level} XP</p>
  </div>
);

export const CardTile = ({ c, onRemove, testid }) => (
  <div className="group relative" data-testid={testid}>
    <img src={c.image_small} alt={c.name} loading="lazy" className="w-full aspect-[63/88] object-cover rounded-lg shadow-[0_10px_25px_-12px_rgba(110,63,184,.6)] group-hover:-translate-y-1 transition-transform" />
    {c.quantity > 1 && <span className="absolute top-1.5 left-1.5 badge-pill bg-[#120E1F] text-[#F2C230]">×{c.quantity}</span>}
    {onRemove && <button onClick={onRemove} data-testid={`${testid}-remove`} className="absolute top-1.5 right-1.5 h-6 w-6 rounded-full bg-[#120E1F]/80 text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity">✕</button>}
    <p className="text-xs mt-2 font-medium text-[#120E1F] truncate">{c.name}</p>
    <p className="text-[10px] text-[#707783] truncate">{c.set_name} · #{c.number}</p>
  </div>
);
